import { MessageCircle } from 'lucide-react';
import styles from './ChatButton.module.css';

export default function ChatButton({ onClick }) {
  return (
    <button className={styles.button} onClick={onClick} aria-label="Chat with AI">
      <MessageCircle size={16} />
      <span className={styles.label}>Ask AI</span>
    </button>
  );
}
